/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint linebreak-style: ["error", "windows"] */
/**
 * Handle Slide Change
 */
const handleSlideChange = () => {
  const slicks = [...document.querySelectorAll('[data-plugin-slick]')];

  let i;
  for (i = 0; i < slicks.length; i++) {
    const $item = jQuery(slicks[i]);
    $item.on('init afterChange', (event, slick, currentSlide, nextSlide) => {
      console.log('Slick has Init or Slide has been changed');
    });

    $item.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      console.log('Slick slide will change.');
    });
  }
};

// Export
export default {
  init: () => {
    // Some demo JS for this route
    handleSlideChange();
  },
  complete: () => {
    const { templateDirectory, fn: { loadJs, getOptions } } = am2;

    console.log('Slider JS Loaded - Should load after Common Init but before Complete.');

    loadJs(`${templateDirectory}/resources/js/vendor/slick.min.js`, () => {
      const slicks = [...document.querySelectorAll('[data-plugin-slick]')];
      for (let i = 0; i < slicks.length; i++) {
        $(slicks[i]).slick(getOptions(slicks[i].dataset.options));
      }
    });
  },
  //extends: ['home', 'single', 'page', 'archive', 'blog', 'am2-slider-loaded']
  extends: ['page', 'single', 'blog', 'archive']
};